import { render, staticRenderFns } from "./organization_member.vue?vue&type=template&id=284d7e1a&scoped=true&"
import script from "./organization_member.vue?vue&type=script&lang=js&"
export * from "./organization_member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284d7e1a",
  null
  
)

export default component.exports